/* eslint-disable no-console */
/* global barba, barbaRouter */
/* globals scrollDepth */
import vars from './helpers';
import analytics from './components/analytics'; // находится в папке analytics
import home from './pages/home';
import share from './share';
import video from './components/video';
import Vivus from 'vivus';
// import share from "./components/share";
// import menu from "./components/header";
if (history.scrollRestoration) {
	history.scrollRestoration = 'manual';
}

const routes = [ // здесь добавляем роуты страниц
	{
		path: '/',
		name: 'index',
	},
];

barba.use(barbaRouter, {
	routes,
});

barba.hooks.enter((data) => {
	vars.$document.trigger(
		'page-enter',
		[data.current.namespace, data.next.namespace], // обработчик для аналитики
	);
});

barba.hooks.beforeEnter(() => {
	vars.scrollTo(vars.$html, 0);
	vars.$html.removeClass('no-scroll');
});

barba.hooks.afterEnter((data) => {
	scrollDepth.reset();
	analytics.start15SecTimeout();
	analytics.init(); // для глобальных фукций инициализируем здесь (Это шеринги, аналитика, меню и т.д)
	share.init();

	console.log('barba.hooks.afterEnter');

	if (data.next.namespace === 'home') {
		home.init();

		setTimeout(function () {
			video.init();
		}, 2000);
	}

	$(data.next.container).find('.is-page-preload').addClass('hide');
});

barba.hooks.beforeLeave((data) => {
	// здесь убираем события

	if (data.next.namespace === 'home') {
		console.log('article.destroy');
	}
});

barba.hooks.beforeLeave(() => {
	// analytics.destroy();
});

// init Barba
barba.init({
	sync: true,
	timeout: 2000,
	transitions: [
		{
			name: 'none',
			leave(data) {
				let done = this.async();

				gsap.to(data.current.container, {
					duration: 0.4,
					autoAlpha: 0,
					onComplete: () => {
						done();
					},
				});
			},
			enter(data) {
				let done = this.async();
				gsap.from(data.next.container, {
					duration: 0.4,
					autoAlpha: 0,
					onComplete: done,
				});
			},
			appear() {
			},
		},
		{
			name: 'slide-enter[-index]',
			appear() {
			},
		},
	],

	views: [
		{
			namespace: 'index',
		},
	],
});
export default barba;
// import {Router} from 'ninelines-router';
//
// import helpers from './helpers';
// import animation from './animation';
// // import setSubmitForm from './components/form';
//
// history.scrollRestoration = 'manual';
//
// const router = new Router({
//
// 	onEnter(prevState, curState) {
// 		window.scrollTo(0, 0);
//
// 		helpers.setPage(curState.route.name, curState.params.id);
//
// 		// if (curState.route.name === 'article' && curState.params.id === '3') {
// 		// 	router.navigate('/');
// 		// }
//
// 		// setSubmitForm();
//
// 		return animation.enter(curState.route.name, curState.params.id);
// 	},
//
// 	onLeave(curState) {
// 		if (curState.route) {
// 			return animation.leave(curState.route.name, curState.params.id);
// 		}
//
// 		return Promise.resolve();
// 	},
//
// 	onNotFound() {
// 		router.navigate('/');
//
// 		return Promise.resolve();
// 	},
//
// });
//
// router.addRoute({
// 	path: '/',
// 	name: 'home',
// });
//
// router.addRoute({
// 	path: '/article/:id',
// 	name: 'article',
// });
//
// router.start();
//
// export default router;
